import CustomScrollbars from './CustomScrollbars';

export default CustomScrollbars;